export default (string) => {
  if (string) {
    const changeCase = string.toUpperCase();

    return changeCase === 'TRUE';
  }

  return false;
};
